import React from 'react';
import ScheduleCourseComponent from 'Components/Card/Components/ScheduleCourseComponent';
import withSMARTGoalOnUpdateCardComponent from 'Components/Card/hoc/withSMARTGoalOnUpdateCardComponent';

function ScheduledCourseCard(props) {
    const { ScheduledCourse: course } = props.data;

    return (
        <ScheduleCourseComponent course={course} />
    )
}

export default withSMARTGoalOnUpdateCardComponent(ScheduledCourseCard);
